import { useDispatch, useSelector } from "react-redux";
import {
  FNAReportsSelector,
  setFNAConsumptionReport,
  setMessage,
  setShowModal,
} from "../store/slices/FNAReportSlice";
import { IConsumptionReportBody, IFNAFormReport, IReportHook, IReportType } from "../store/models/FNAModel";
import { getConsumptionReportAC, getFNAConsumptionReportAC } from "../store/action-creators/FNAReportsActionCreators";
import { useEffect, useState } from "react";
import { decodeToken, downloadDataFromBase64ToZip } from "../utils/general/utils";
import { DataToken } from "../store/types";
import { FNA_POINT } from "../config/const";
import moment from "moment";

const typeReportsLists = [{
  name: "Reporte de consumo",
  value: 1
}];

// Las fechas elegidas en el input llegan como medianoche UTC; la fecha por defecto es local
const formatReportDate = (date?: Date) => {
  const value = moment(date);
  const isUtcMidnight = value.utc().format("HH:mm:ss.SSS") === "00:00:00.000";
  return isUtcMidnight ? value.utc().format("YYYY-MM-DD") : value.local().format("YYYY-MM-DD");
};

const useFNAReports = ({ token, nitCompany }: IReportHook) => {
  // REDUX state
  const dispatch = useDispatch();
  const [reportTypeList, setReportTypeList] = useState<IReportType[]>(typeReportsLists);
  const [decodedToken, setDecodedToken] = useState<DataToken | undefined>(undefined);
  const { consumptionFNA, showModal, message, isLoading } =
    useSelector(FNAReportsSelector);

  useEffect(() => {
    if (consumptionFNA !== null) {
      downloadDataFromBase64ToZip(consumptionFNA.file, consumptionFNA.fileName);
      dispatch(setFNAConsumptionReport(null));
    }
  }, [consumptionFNA]);

  const getFNAConsumptionReport = (body: IFNAFormReport) => {
    if (decodedToken?.customer_value === FNA_POINT) {
      dispatch(getFNAConsumptionReportAC(body));
      return;
    }
    const consumptionBody: IConsumptionReportBody = {
      startDate: formatReportDate(body.initDate),
      endDate: formatReportDate(body.endDate),
    };
    dispatch(getConsumptionReportAC(consumptionBody));
  };

  const handleCloseModal = () => {
    dispatch(setShowModal(false))
    dispatch(setMessage(""))
  }

  useEffect(() => {
    if (token) {
      const decodeNewToken: any = decodeToken(token);
      setDecodedToken(decodeNewToken);
    }
  },[token]);

  function haveReportsAvailable (_decodedToken:DataToken | undefined){
    if ( decodedToken?.BIOMETRIA_ROLE === "BIOMETRIA ADMIN" || decodedToken?.BIOMETRIA_ROLE === "BIOMETRIA SUPERADMIN" ) return true;
    return false;
  }

  return {
    consumptionFNA,
    showModal,
    message,
    isLoading,
    getFNAConsumptionReport,
    handleCloseModal,
    reportTypeList,
    setReportTypeList,
    decodedToken,
    haveReportsAvailable
  };
};

export default useFNAReports;
